export default __webpack_public_path__ + "static/media/blogbackground.d5f990e6.png";